import React, { useState } from "react";
import FilterBox from "./FilterBox/FilterBox";
import FilterCheckbox from "./FilterCheckbox";

export default function Filters({ 
    filters, 
    config, 
    searchInputs, 
    selectedFilterItems, 
    selectedFilterItemsNotEmpty,
    handleFilterItemSelect, 
    handleFilterItemsReset,
    setSearchInputs,
    defaultOpenFilters = {},
}) {
    let [openFilters, setOpenFilters] = useState({
        'kategoria#filter_2': true,
        'kategoria#idegen-nyelvu-konyvek': true,
        ...defaultOpenFilters
    });

    const toggleFilterOpen = (param, defValue) => {
        setOpenFilters(prev => ({
            ...prev,
            [param]: typeof prev[param] != 'undefined' ? !prev[param] : !!defValue
        }));
    }

    return (
        <div
            className="list-filter-col col-lg-3 new-filters"
        >
            <p
                className="mb-1"
                style={{ fontWeight: 700, color: "#291669", fontSize: 24 }}
            >
                Szűrés
            </p>
            {Object.keys(config.filters).map((cIndex) => {
                if(cIndex === "separator")
                    return <hr key="separator" className="separator" />

                const index = cIndex.split("#")
                const filter = filters.find(f => f.param === index[0] && (index[1] ? f.id == index[1] : true));
                
                if(!filter)
                    return null;

                return (filter.param === "tipus" && !filter.items[0]?.items)
                    ? filter.items.map((item) => (
                            <FilterCheckbox
                                key={item.id}
                                item={item}
                                className="type-filter-checkbox"
                                param="tipus"
                                multi={false}
                                selectedItems={selectedFilterItems.tipus || []}
                                onSelect={handleFilterItemSelect}
                            />
                        ))
                    : searchInputs[filter.param] != null && (
                            <FilterBox
                                key={index}
                                selected={selectedFilterItems}
                                {...filter}
                                {...config.filters[filter.param + (index[1] ? "#" + index[1] : "")]}
                                param={filter.param}
                                onSelect={handleFilterItemSelect}
                                searchInput={searchInputs[filter.param]}
                                multi={config.filters[filter.param]?.multi ?? false}
                                setSearchInput={(v) => {
                                    let searchData = { ...searchInputs };
                                    searchData[filter.param] = v;
                                    setSearchInputs(searchData);
                                }}
                                openFilters={openFilters}
                                toggleFilterOpen={toggleFilterOpen}
                            />
                        )
                }
            )}
            {selectedFilterItemsNotEmpty(selectedFilterItems) && (
                <div className="d-flex justify-content-end w-full">
                    <button
                        className="clear-filters-btn"
                        onClick={handleFilterItemsReset}
                    >
                        Szűrők törlése
                    </button>
                </div>
            )}
        </div>
    )
}